export default __webpack_public_path__ + "static/media/91.59a93a05.jpeg";